import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { getShortLabel } from 'utils/sources'
import { getCurrentAppId, getComponent } from 'ducks/editor/objects'

import { getDatasources } from 'ducks/apps/datasources'
import Icon from 'components/Shared/Icon'
import ToggleButton from 'components/Shared/Forms/ToggleButton'

import GenericInspectRow from '../GenericRow'

import './BooleanControl.scss'

class BooleanControl extends Component {
  handleChange = value => {
    const { onChange, name } = this.props

    onChange({ [name]: value })
  }

  handleToggle = () => {
    const { value } = this.props

    return this.handleChange(!value)
  }

  handleAddBinding = newValue => {
    const { onChange, name } = this.props

    if (newValue) {
      onChange({ [name]: newValue })
    }
  }

  handleRemoveBinding = () => {
    const { onChange, name } = this.props

    onChange({ [name]: false })
  }

  render() {
    const { boxed, displayName, label, value } = this.props

    if (typeof value === 'object' && label) {
      return (
        <div className="library-inspect-boolean-binding">
          {label}
          <Icon type="close" onClick={this.handleRemoveBinding} />
        </div>
      )
    }

    if (boxed) {
      return (
        <GenericInspectRow title={displayName} className="toggle-button-block">
          <div className="toggle-button-block-box">
            {value ? 'On' : 'Off'}
            <ToggleButton value={value} onChange={this.handleToggle} />
          </div>
        </GenericInspectRow>
      )
    }

    return (
      <div
        className={classNames(
          'boolean-control',
          'boolean-control-standalone',
          'library-inspect-boolean-control',
          { 'boolean-control-boxed': boxed }
        )}
        onClick={this.handleToggle}
      >
        {displayName ? <p>{displayName}</p> : null}
        <ToggleButton value={!!value} onChange={this.handleChange} />
      </div>
    )
  }
}

const mapStateToProps = (state, { objectId, value, role, reference }) => {
  const appId = getCurrentAppId(state)
  const componentId = getComponent(state, objectId)?.id
  let label

  if (typeof value === 'object') {
    label = getShortLabel(state, value.source, appId, componentId)
  }

  return {
    label,
    datasources: getDatasources(state, appId),
  }
}

export default connect(mapStateToProps)(BooleanControl)
